
import React from 'react';
import Loadable from '@react-loadable/revised';

export const headerFactoryMap = {
	1: Loadable({ loader: () => import('../Headerv2/Layouts/HeaderL1.js'), loading: () => <div></div> }),
	2: Loadable({ loader: () => import('../Headerv2/Layouts/HeaderL2.js'), loading: () => <div></div> }),
	3: Loadable({ loader: () => import('../Headerv2/Layouts/HeaderL3.js'), loading: () => <div></div> }),
}